const JWT_PATTERN = /^eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/;

const STATUS_MESSAGES = {
  400: '잘못된 요청입니다.',
  401: '인증이 필요합니다. 다시 로그인해 주세요.',
  403: '접근 권한이 없습니다.',
  404: '요청한 정보를 찾을 수 없습니다.',
  409: '요청이 충돌했습니다.',
  413: '업로드 파일 크기가 너무 큽니다.',
  500: '서버 오류가 발생했습니다.',
};

const defaultMessageForStatus = (status) => STATUS_MESSAGES[status] || '요청 처리 중 오류가 발생했습니다.';

export const parseResponseText = (text) => {
  if (!text || !text.trim()) {
    return null;
  }

  const trimmed = text.trim();

  try {
    return JSON.parse(trimmed);
  } catch {
    if (JWT_PATTERN.test(trimmed)) {
      return trimmed;
    }
    throw new Error(trimmed);
  }
};

export const extractAccessToken = (data) => {
  if (!data) return null;
  if (typeof data === 'string') return data;
  if (typeof data.accessToken === 'string') return data.accessToken;
  return null;
};

const collectDetailMessages = (details) => {
  if (!details || typeof details !== 'object') return [];

  return Object.values(details)
    .filter((value) => typeof value === 'string' && value.trim())
    .map((value) => value.trim());
};

export const extractErrorMessage = (text, status = 0) => {
  if (!text || !text.trim()) {
    return defaultMessageForStatus(status);
  }

  const trimmed = text.trim();

  if (JWT_PATTERN.test(trimmed)) {
    return '인증이 만료되었습니다. 다시 로그인해 주세요.';
  }

  try {
    const parsed = JSON.parse(trimmed);
    return formatParsedError(parsed, status);
  } catch {
    if (trimmed.startsWith('Unexpected token')) {
      return '서버 응답 형식이 올바르지 않습니다. 다시 로그인해 주세요.';
    }

    return trimmed.length > 300 ? `${trimmed.slice(0, 300)}...` : trimmed;
  }
};

const formatParsedError = (parsed, status) => {
  if (typeof parsed === 'string') {
    return parsed;
  }

  if (!parsed || typeof parsed !== 'object') {
    return defaultMessageForStatus(status);
  }

  const detailMessages = collectDetailMessages(parsed.details);
  const baseMessage =
    parsed.message
    || parsed.error
    || parsed.detail
    || parsed.title
    || defaultMessageForStatus(status);

  if (detailMessages.length > 0) {
    return `${baseMessage} (${detailMessages.join(', ')})`;
  }

  return baseMessage;
};

export const readResponseBody = async (response) => {
  if (response.status === 204) {
    return null;
  }

  const text = await response.text();
  return parseResponseText(text);
};

export const readErrorMessage = async (response) => {
  const text = await response.text();
  return extractErrorMessage(text, response.status);
};
